import React from 'react';
import { Button, Form } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { CustomerTagContext } from 'src/pages/CustomerDatabaseConfig/CustomerTag/Detail';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const Item = Form.Item;
const Clear = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { onClick, className, disabled } = props;
  const { setHasModified } = React.useContext(CustomerTagContext);
  return (
    <Button
      disabled={disabled}
      onClick={() => {
        if (onClick) onClick();
        if (setHasModified) setHasModified(true);
      }}
      className={`${css.btn} ${className || ''}`}>
      {getI18n('general.advancedFilters.commonStoreProductsWithTable.clear')}
    </Button>
  );
};
const IntClear = (props) => {
  const { form, root, value, state, hasValue, disabled } = props;
  return (
    <Item
      shouldUpdate={(p, c) => {
        const touched = form.isFieldTouched(root);
        return touched; //|| cv !== pv;
      }}>
      {(f) => {
        const { getFieldValue } = f;

        const _hasValue = hasValue || getFieldValue(value);

        if (_hasValue) {
          return (
            <Clear
              disabled={disabled}
              onClick={() => {
                form.setFieldsValue(state);
              }}
            />
          );
        }
      }}
    </Item>
  );
};
export { IntClear };
export default Clear;
